import { Box, Typography, Container } from "@mui/material";
import { styled } from "@mui/material/styles";
import { translations } from "../translations";

const touristsImg = "/assets/tourists-and-travelers.webp";
const businesspeopleImg = "/assets/businesspeople-engag.webp";
const anyoneWhoValuesImg = "/assets/anyone-who-values.webp";

// Horizontal panel - slightly less than full viewport width to show next card
const Panel = styled(Box)(({ theme }) => ({
  width: "85vw",
  height: "100%",
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  willChange: "transform",
  marginRight: "20px",
  [theme.breakpoints.down("lg")]: {
    width: "100vw",
    height: "auto",
    padding: theme.spacing(5, 0),
    marginRight: 0,
  },
}));

// Content container inside each panel
const PanelContent = styled(Container)(({ theme }) => ({
  maxWidth: "1400px",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  padding: "0 24px",
  [theme.breakpoints.down("md")]: {
    padding: "0 16px",
  },
}));

// Card wrapper - wider for horizontal scroll
const Card = styled(Box)(() => ({
  overflow: "hidden",
  width: "100%",
  display: "flex",
  flexDirection: "column",
}));

const CardImage = styled(Box)(({ theme }) => ({
  height: "calc(100vh - 200px)",
  maxHeight: "600px",
  backgroundSize: "cover",
  backgroundPosition: "center",
  borderRadius: "40px",
  overflow: "hidden",
  [theme.breakpoints.down("md")]: {
    height: "480px",
    borderRadius: "20px",
  },
  [theme.breakpoints.down("sm")]: {
    height: "300px",
  },
}));

const CardTextContainer = styled(Box)(({ theme }) => ({
  padding: "30px 0 0 0",
  [theme.breakpoints.down("md")]: {
    padding: "20px 0 0 0",
  },
}));

const CardTitle = styled(Typography)(({ theme }) => ({
  lineHeight: "normal",
  ...theme.typography.h3,
  color: "var(--text-primary)",
  [theme.breakpoints.down("md")]: {
    fontSize: "20px",
  },
}));

export default function TestimonialsSlider() {
  const t = translations;

  const testimonials = [
    { image: touristsImg, title: t.touristsTitle },
    { image: businesspeopleImg, title: t.businessTitle },
    { image: anyoneWhoValuesImg, title: t.citizensTitle },
  ];

  return (
    <>
      {testimonials.map((testimonial, index) => (
        <Panel key={index} className="panel-horizontal">
          <PanelContent>
            <Card>
              <CardImage
                style={{ backgroundImage: `url(${testimonial.image})` }}
              />
              <CardTextContainer>
                <CardTitle variant="h5">{testimonial.title}</CardTitle>
              </CardTextContainer>
            </Card>
          </PanelContent>
        </Panel>
      ))}
    </>
  );
}
